module.exports = "static/assets/f63b1189ab5032e40f77182f567fd1da.png";